<template>
  <v-card>
    <v-card-title>
      <span class="headline">История операций по счётчику</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex
            xs12
            sm12
            md12
          >
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              fixed-header
              no-data-text="Нет данных для отображения"
              :footer-props="{
                itemsPerPageText: 'Число счетчиков на странице',
                itemsPerPageOptions: [25, 50]
              }"
              class="counter-history-table"
              dense
            >
              <tr
                slot="item"
                slot-scope="props"
              >
                <td class="text-right">
                  {{ props.item.counter_serial_num }}
                </td>
                <td class="text-right">
                  {{ props.item.operation_date | moment("DD/MM/YYYY HH:mm:ss") }}
                </td>
                <td class="text-right">
                  {{ props.item.coper_type_name }}
                </td>
                <td class="text-right">
                  {{ props.item.comment }}
                </td>
                <td class="text-right">
                  {{ props.item.point_name }}
                </td>
                <td class="text-right">
                  {{ props.item.user_name }}
                </td>
              </tr>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        @click.native="close"
      >
        Закрыть
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CounterHistory',
  props: {
    counterData: {}
  },
  data () {
    return {
      loading: true,
      options: {},
      items: [],
      serverItemsLength: 0,
      headers: [
        {
          text: 'Номер счётчика',
          align: 'right',
          sortable: false,
          value: 'counter_serial_num'
        },
        {
          text: 'Дата операции',
          align: 'right',
          sortable: false,
          value: 'operation_date'
        },
        {
          text: 'Тип операции',
          align: 'right',
          sortable: false,
          value: 'coper_type_name'
        },
        {
          text: 'Комментарий',
          align: 'right',
          sortable: false,
          value: 'comment'
        },
        {
          text: 'Имя Точки учёта',
          align: 'right',
          sortable: false,
          value: 'point_name'
        },
        {
          text: 'Логин пользователя',
          align: 'right',
          sortable: false,
          value: 'user_name'
        }
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.getCounterHistoryApi()
      },
      deep: true
    }
  },
  methods: {
    getCounterHistoryApi () {
      this.loading = true
      axios.get(`/api/counteropers/?counter_id=${this.counterData.counter_id}&per_page=${this.options.itemsPerPage}&page=${this.options.page}`)
        .then((response) => {
          this.items = response.data.results
          this.serverItemsLength = response.data.count
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .counter-history-table .v-data-table__wrapper {
    max-height: 480px;
  }
</style>



// WEBPACK FOOTER //
// src/spa/counters/CounterHistory.vue